import React from 'react';

import CommonModal from '../CommonModal';

interface IConfirmationModalCmpProps {
    title: string;
    description: string;
    handleClose: () => void;
    handleSubmit?: () => void;
    handleSecondaryBtn?: () => void;
    isSubmitting?: boolean;
    submitBtnText?: string;
    dangerBtnText?: string;
    secondaryBtnText?: string;
    secondaryBtnLoading?: boolean;
    isPrimaryDangerBtn?: boolean;
    size?: string;
}

const ConfirmationModalCmp: React.FC<IConfirmationModalCmpProps> = ({
    title,
    description,
    handleClose,
    handleSubmit,
    handleSecondaryBtn,
    isSubmitting = false,
    submitBtnText = 'Confirm',
    dangerBtnText,
    secondaryBtnText,
    secondaryBtnLoading = false,
    isPrimaryDangerBtn = false,
    size = 'max-w-[400px]',
}) => (
    <CommonModal
        title={title}
        modalTitleDesc={description}
        size={size}
        handleClose={() => handleClose()}
        modalHeaderClass="border-b-0 !px-6 !pt-6 !pb-5 !bg-transparent"
        modalHeaderTextClass="!flex-col"
        modalFooterClass="border-t-0 !bg-transparent"
        closeBtnClass="-mt-2 -mr-2"
        primaryBtnText={isPrimaryDangerBtn ? undefined : submitBtnText}
        dangerBtnText={isPrimaryDangerBtn ? dangerBtnText : undefined}
        primaryBtnOnClick={handleSubmit}
        primaryBtnLoading={isSubmitting}
        primaryBtnDisabled={isSubmitting}
        secondaryBtnText={secondaryBtnText}
        secondaryBtnOnClick={handleSecondaryBtn}
        secondaryBtnLoading={secondaryBtnLoading}
        secondaryBtnDisabled={secondaryBtnLoading}
        closeOnOutsideClick={!isSubmitting && !secondaryBtnLoading}
        isEscapeClose={!isSubmitting && !secondaryBtnLoading}
    >
        <></>
    </CommonModal>
);

export default ConfirmationModalCmp;
